import { Injectable } from '@angular/core';
import {
  HttpHeaderResponse,
  HttpProgressEvent,
  HttpRequest,
  HttpResponse,
  HttpSentEvent,
  HttpUserEvent
} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {ToastrService} from "ngx-toastr";

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  constructor(private toastrService: ToastrService) {}

  handle(request: HttpRequest<any>,
         evt: HttpSentEvent | HttpHeaderResponse |
             HttpResponse<any> | HttpProgressEvent |
             HttpUserEvent<any>): void {
    if (evt instanceof HttpResponse) {
      if (!environment.disableTosterUrl.some(value => value == request.url)) {
        if (request.method === 'GET' || request.url.endsWith('login')) {
        } else {
          this.handle_201_204(evt.body)
        }
      }
    }
  }

  public handle_201_204(body: any): void {
    this.toastrService.success(
        body?.message,
        'Success',
        {toastClass: 'toast-icon custom-toast-success'}
    );
  }
}
